import axios from 'axios'

let navigate: ((path: string) => void) | null = null
let logoutFunction: (() => Promise<void>) | null = null

// Setup function to be called from the AuthProvider
export const setupAxiosInterceptor = (
  navigateFn: (path: string) => void,
  logoutFn: () => Promise<void>
) => {
  navigate = navigateFn
  logoutFunction = logoutFn
}

// Request interceptor to add token to headers
axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle auth errors
axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const { response } = error

    if (response?.status === 401) {
      // Token is invalid or expired - logout user
      console.warn('Session expired or invalid token. Logging out...')

      if (logoutFunction) {
        await logoutFunction()
      } else {
        // Fallback: process logout manually with API call
        try {
          const { logout } = await import('@/api/login')
          await logout()
        } catch (logoutError) {
          console.warn(
            'Logout API call failed during 401 handling:',
            logoutError
          )
        } finally {
          // Always clear storage and redirect
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('regions')
          if (navigate) {
            navigate('/login')
          } else {
            window.location.href = '/login'
          }
        }
      }
    } else if (response?.status === 403) {
      // User is authenticated but not authorized for this resource
      console.warn('Access denied. Redirecting to unauthorized page...')

      if (navigate) {
        navigate('/unauthorized')
      } else {
        window.location.href = '/unauthorized'
      }
    }

    return Promise.reject(error)
  }
)
